var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_c('van-popup',{attrs:{"value":_vm.show},on:{"click-overlay":_vm.close}},[_c('NotificationContent',{ref:"NotificationContent",on:{"close":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }